<template>
  <div class="header header-fixed header-logo-center">
    <router-link to="/home" class="header-title color-theme"><slot></slot></router-link>
    <i @click="changeMode()" class="header-icon color-theme header-icon-4">
      <i class="fas fa-lightbulb"></i>
    </i>
    <p class="header-icon header-icon-1">
      <i @click="refreshMessages($route.params.type.toString()+'s', $route.params.id)" class="fas fa-sync"></i>
    </p>
  </div>
</template>

<script>
import global from "@/mixins/global";

import { mapMutations } from "vuex"
export default {
  name: "AdminChatBar",
  mixins: [global],
  methods: {
    ...mapMutations(["updateMode"]),
    changeMode(){
      this.updateMode()
    }
  }
}
</script>

<style>

</style>